<template>
  <div class="community-posts" id="homepage">
    <div class="info-button" :class="openPanel ? 'opened' : ''" @click="toggleOpenPanel">
      <ConfigIcon :size="27" class="info-icon" />
    </div>
    <div @click="toggleOpenPanel" class="transparent-exit" :class="openPanel ? 'opened' : ''"></div>

    <div class="fixed-panel fixed-panel-right">
      <div class="bloc-right" v-if="suggestedCommunities.length>0">
        <suggested-communities :communities="suggestedCommunities" />
      </div>
      <read-about-tile />
    </div>
    <div id="page-content" v-if="communityDetail.community.type !== ''">
      <post-create
        v-if="userIsMember"
        :community-list="[communityDetail.community]"
        :owner="communityDetail.owner"
        :first-post="communityPosts.length === 0"
        :multiple-community-choice="false"
      />
      <join-community
        v-if="!userIsMember"
        :community="communityDetail.community"
      />
      <sorting-menu
        type="posts"
        v-if="communityPosts.length !== 0 || currentSort === 'popularity'"
      />
      <div v-if="communityPosts">
        <div
          v-for="post in communityPosts"
          :key="post.id"
        >
          <div v-if="post.type === 'post'">
            <Post :post="post" />
          </div>
          <div v-else-if="post.type === 'welcome'">
            <welcome-post :post="post" />
          </div>
        </div>
      </div>
      <span v-if="communityPosts.length === 0">
        <logo-background />
      </span>
      <infinite-loading
        v-if="this.$store.getters.postsSort === 'chronology'"
        :identifier="infiniteLoadingId"
        @infinite="loadMoreCommunityPosts"
      >
        <div slot="no-results"></div>
        <div slot="no-more"></div>
      </infinite-loading>
    </div>
    <div class="info-wrapper" ref="container" :style="{ top: `${top + topUnity}` }" :class="openPanel ? 'opened' : ''">
      <div class="header" ref="target">
        <ChevronDoubleDown :size="30" @click="toggleOpenPanel()" />
      </div>

      <div class="container yellow-scroll">
        <div class="fixed-panel fixed-panel-left">
          <community-info :community-detail="communityDetail" :user-is-member="userIsMember" />
          <cancel-owner-request
            v-if="this.communityDetail.idUser === this.$store.getters.auth.id"
            :community-detail="communityDetail"
          />
          <join-request-tile
            v-if="this.communityDetail.idUser === this.$store.getters.auth.id"
            :community-detail="communityDetail"
          />
          <owner-request-tile :community-detail="communityDetail" />
          <community-members
            v-if="userIsMember && communityDetail.community.type === 'private' || communityDetail.community.type === 'public'"
            :members="communityDetail.members"
          />
          <community-documents
            v-if="userIsMember && communityDetail.community.type === 'private' || communityDetail.community.type === 'public'"
            :documents="communityDetail.documents"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CommunityInfo from './CommunityInfo'
import CommunityMembers from './CommunityMembers'
import CommunityDocuments from './CommunityDocuments'
import InfiniteLoading from 'vue-infinite-loading'
import Post from '../post/Post'
import WelcomePost from '@/components/post/WelcomePost'
import LogoBackground from '@/components/shared/LogoBackground'
import PostCreate from '@/components/post/PostCreate'
import JoinCommunity from '@/components/community/JoinCommunity'
import JoinRequestTile from '@/components/community/JoinRequestTile'
import OwnerRequestTile from '@/components/community/OwnerRequestTile'
import CancelOwnerRequest from '@/components/community/CancelOwnerRequest'
import SortingMenu from '@/components/shared/SortingMenu'
import ReadAboutTile from '@/components/shared/ReadAboutTile'
import SuggestedCommunities from '@/components/shared/SuggestedCommunities'
import { mapState } from 'vuex'
import ConfigIcon from 'vue-material-design-icons/CogOutline.vue'
import ChevronDoubleDown from 'vue-material-design-icons/ChevronDoubleDown.vue'
import swipe from '@/components/post/Swipe'
import { ref } from 'vue'
const top = ref(100)
const topUnity = ref('vh')

export default {
  name: 'Community',
  components: {
    ChevronDoubleDown,
    CommunityInfo,
    CommunityMembers,
    CommunityDocuments,
    Post,
    InfiniteLoading,
    PostCreate,
    JoinCommunity,
    LogoBackground,
    SortingMenu,
    JoinRequestTile,
    ReadAboutTile,
    SuggestedCommunities,
    WelcomePost,
    OwnerRequestTile,
    CancelOwnerRequest,
    ConfigIcon
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  watch: {
    comment() {
      this.loadCommunityData()
    }
  },
  data() {
    return {
      suggestedCommunities: [],
      currentYPosition: 0,
      openPanel: false,
      top: top,
      topUnity: topUnity
    }
  },
  async created() {
    this.suggestedCommunities = await this.$store.dispatch('suggestedCommunities')
    this.loadCommunityData(this.id)
    window.addEventListener('scroll', this.logit)
  },
  beforeMount() {
    top.value = 100
    topUnity.value = 'vh'
  },
  mounted() {
    swipe.setSwipe(top,
      this.toggleOpenPanel,
      this.$refs['target'],
      this.$refs['container'],
      200,
      0)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.logit)
    document.body.classList.remove('noscroll')
  },
  unmounted() {
    window.removeEventListener('scroll', this.logit)
    document.body.classList.remove('noscroll')
  },
  beforeRouteUpdate(to, from, next) {
    this.loadCommunityData(to.params.id)
    next()
  },
  methods: {
    async loadCommunityData(id) {
      this.$store.dispatch('resetCommunityJoinRequests')
      this.$store.dispatch('resetPosts')
      this.$store.dispatch('resetPostFilter')
      let success = await this.$store.dispatch('fetchCommunityDetails', id)
      if (success) {
        this.$store.dispatch('fetchCommunityPosts', id)
        // if private community
        if (this.$store.getters.communityDetail.community.type === 'private') {
          this.$store.dispatch('fetchUserJoinRequests')
          this.$store.dispatch('fetchCommunityJoinRequests', id)
          this.$store.dispatch('searchUsersByCommunity', id)
        } else {
          this.$store.dispatch('searchUsersByPublicCommunity', id)
        }
      } else {
        this.$router.push({ name: 'notFound', params: { component: 'community' } })
      }
    },
    async loadMoreCommunityPosts($state) {
      await this.$store.dispatch('fetchCommunityPosts', this.id)
      if (this.$store.getters.cursors.hasNext) {
        $state.loaded()
      } else {
        $state.complete()
      }
    },
    toggleOpenPanel() {
      if (!this.openPanel) {
        top.value = 200
        topUnity.value = 'px'
        document.body.classList.toggle('noscroll', true)
      } else {
        top.value = 100
        topUnity.value = 'vh'
        document.body.classList.remove('noscroll', true)
      }
      this.openPanel = !this.openPanel
    },
    logit() {
      if (window.pageYOffset > window.innerHeight && this.currentYPosition < window.innerHeight) {
        this.currentYPosition = window.pageYOffset
        this.$store.dispatch('triggerScroll', window.location.pathname)
      }
    }
  },
  computed: {
    communityPosts() {
      return this.$store.getters.communityPosts(this.id)
    },
    userIsMember() {
      return this.$store.getters.userCommunities.map(userCommunity => userCommunity.idCommunity).includes(this.id)
    },
    infiniteLoadingId() {
      return this.$store.getters.postsFilter + new Date()
    },
    currentSort() {
      return this.$store.getters.postsSort
    },
    ...mapState({
      communityDetail: state => state.community.communityDetail
    })
  }
}
</script>
<style scoped src="@/sass/info-responsive.scss" lang="scss"/>
<style scoped lang="scss">
#homepage {
  display: flex;
  justify-content: center;
  margin: 0 auto;
  max-width: 50vw;
  min-height: auto;
  padding-bottom: 70px !important;
  @media (max-width: $medium) {
    left: 25vw;
    max-width: 50vw;
  }
  @media (max-width: $header-change) {
    max-width: 100vw;
    left: auto;
  }
}
#page-content {
  width: 100%;
}
.fixed-panel {
  position: fixed;
}

.community-detail {

  .community-posts {
    display: flex;
    flex-direction: column;
    width: 638px;
  }
  .bloc-right {
    width: 291px;
    height: fit-content;
    margin: 1rem;
    padding-bottom: 1rem;
    background-color: white;
    border-top: solid 2px $secondary-color;
    box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
  }
}

</style>
